var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"status-bar"},[_c('video-status-header',{attrs:{"connected":_vm.isConnected,"intent":"guest"}})],1),_c('video-chat-body',{attrs:{"intent":"guest"},on:{"connectedChanged":_vm.onConnectedChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }